(function () {
  'use strict';

  angular
    .module('service.yammer', ['factories.serviceHelper'])
    .factory('yammerService', yammerService);

  yammerService.$inject = ['$http', 'ServiceHelper'];

  function yammerService($http, ServiceHelper) {
    var url = {
      user: 'https://:host/:ipad/gaviota-api/yammer/user/',
      network: 'https://:host/:ipad/gaviota-api/yammer/network/',
      groups: 'https://:host/:ipad/gaviota-api/yammer/group/',
      message: 'https://:host/:ipad/gaviota-api/yammer/messages',
      cModuleInfo: 'https://:host/:ipad/gaviota-api/yammer/cModule/:cModuleId'
    };

    var keys = ['ipad', 'cModuleId'];

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key]
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb)(response.data);
      });
    }

    return {
      getYammerUsers: function (options, resultCb, errorCb) {
        options = _._.defaults(options, {pageId: 1, permalink: ''});
        return ServiceHelper.checkCanCallService(function () {
          return respond($http.get(createUrl(url.user, ServiceHelper.defaultUrlParams()), {
            params: options
          }), resultCb, errorCb);
        });
      },
      getYammerNetworks: function (resultCb, errorCb) {
        return ServiceHelper.checkCanCallService(function () {
          return respond($http.get(createUrl(url.network, ServiceHelper.defaultUrlParams())), resultCb, errorCb);
        });
      },
      getYammerGroups: function (permalink, resultCb, errorCb) {
        return ServiceHelper.checkCanCallService(function () {
          return respond($http.get(createUrl(url.groups, ServiceHelper.defaultUrlParams), {
            params: {
              permalink: permalink
            }
          }), resultCb, errorCb);
        });
      },
      sendYammerMessage: function (options, resultCb, errorCb) {
        return ServiceHelper.checkCanCallService(function () {
          return respond($http.post(createUrl(url.message, ServiceHelper.defaultUrlParams()), options),
            resultCb, errorCb);
        });
      },
      getYammerInfoForCModule: function (cModuleId, resultCb, errorCb) {
        var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {cModuleId: cModuleId});
        return respond($http.get(createUrl(url.cModuleInfo, urlParams)), resultCb, errorCb);
      }
    };
  }

})();
